import React, { useState } from 'react';
import { X, ZoomIn } from 'lucide-react';
import { galleryPhotos } from '../mock';

const Gallery = () => {
  const [active, setActive] = useState(null);

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-10 lg:mb-12 reveal">
          <span className="inline-block px-3 py-1 rounded-full bg-[color:var(--brand-50)] text-[color:var(--brand)] text-xs font-semibold tracking-wider uppercase mb-3">Suasana Outlet</span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-[color:var(--ink)]">
            Outlet <span className="text-[color:var(--brand)]">Trust Me Laundry</span>
          </h2>
          <p className="text-[color:var(--muted)] mt-3 max-w-2xl mx-auto">
            Suasana outlet kami yang nyaman, bersih, dan dilengkapi mesin laundry modern.
          </p>
        </div>

        {/* Asymmetric responsive grid - more interesting layout */}
        <div className="grid grid-cols-4 grid-rows-2 gap-3 sm:gap-4 h-[480px] sm:h-[560px] lg:h-[640px]">
          {/* Large feature photo */}
          <button
            type="button"
            onClick={() => setActive(galleryPhotos[0])}
            className="col-span-2 row-span-2 group relative overflow-hidden rounded-2xl border border-[color:var(--brand-50)] reveal"
          >
            <img src={galleryPhotos[0]} alt="Outlet Trust Me Laundry 1" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between text-white opacity-0 group-hover:opacity-100 transition-opacity">
              <div>
                <div className="font-semibold">Suasana Outlet</div>
                <div className="text-xs text-white/80">Klik untuk perbesar</div>
              </div>
              <ZoomIn className="w-5 h-5" />
            </div>
          </button>

          {/* Top right */}
          <button
            type="button"
            onClick={() => setActive(galleryPhotos[1])}
            className="col-span-2 row-span-1 group relative overflow-hidden rounded-2xl border border-[color:var(--brand-50)] reveal"
          >
            <img src={galleryPhotos[1]} alt="Outlet Trust Me Laundry 2" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" loading="lazy" />
          </button>

          {/* Bottom right - 2 photos */}
          <button
            type="button"
            onClick={() => setActive(galleryPhotos[2])}
            className="col-span-1 row-span-1 group relative overflow-hidden rounded-2xl border border-[color:var(--brand-50)] reveal"
          >
            <img src={galleryPhotos[2]} alt="Outlet Trust Me Laundry 3" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" loading="lazy" />
          </button>
          <button
            type="button"
            onClick={() => setActive(galleryPhotos[3])}
            className="col-span-1 row-span-1 group relative overflow-hidden rounded-2xl border border-[color:var(--brand-50)] reveal"
          >
            <img src={galleryPhotos[3]} alt="Outlet Trust Me Laundry 4" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" loading="lazy" />
          </button>
        </div>

        {/* Extra wide photo below */}
        {galleryPhotos[4] && (
          <button
            type="button"
            onClick={() => setActive(galleryPhotos[4])}
            className="mt-3 sm:mt-4 group relative overflow-hidden rounded-2xl border border-[color:var(--brand-50)] reveal w-full h-[220px] sm:h-[280px] lg:h-[340px]"
          >
            <img src={galleryPhotos[4]} alt="Outlet Trust Me Laundry 5" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
          </button>
        )}
      </div>

      {/* Lightbox */}
      {active && (
        <div
          className="fixed inset-0 z-[80] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4 cursor-zoom-out"
          onClick={() => setActive(null)}
          role="dialog"
          aria-modal="true"
        >
          <button
            type="button"
            className="absolute top-4 right-4 h-10 w-10 rounded-full bg-white/15 hover:bg-white/25 text-white flex items-center justify-center"
            onClick={() => setActive(null)}
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
          <img src={active} alt="Preview" className="max-w-full max-h-full object-contain rounded-xl" />
        </div>
      )}
    </section>
  );
};

export default Gallery;
